import { Card, Grid } from '@mui/material';
import { Outlet, useParams } from 'react-router-dom';
import { SiTrackPage } from '../../../components/si-track-page';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { unitsApiKeyStore } from '../../../api/units-api-key-store';
import { DetailsTabs } from './details-tabs';
import { UnitDetailsForm } from './unit-details.form';

export const UnitDetailsPage = () => {
  const { unitID } = useParams();
  const { data, isLoading, isFetching, refetch } = useLoadData<ApiResponse<any>>(
    unitsApiKeyStore.getUnitDetails(unitID)
  );

  const handleRefretchData = () => {
    refetch();
  };

  return (
    <SiTrackPage title={data?.data?.projectName ?? ''} isLoading={isLoading || isFetching}>
      <Card variant="outlined">
        {data?.data && <UnitDetailsForm unit={data?.data} refetchUnitData={handleRefretchData} />}
      </Card>

      <Grid container spacing={2} style={{ paddingBottom: '10px', marginTop: '0px' }}>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          {data?.data && <DetailsTabs unit={data?.data} />}
        </Grid>
      </Grid>
      <Outlet />
    </SiTrackPage>
  );
};
